// extracted by mini-css-extract-plugin
export default {"userReviews":"style_userReviews__RW7UJ","text1":"style_text1__2VI88","header":"style_header__D2flf","heading":"style_heading__g0VXC","inner":"style_inner__0uMgI"};